import React from "react";

export default function PrintModal({ isOpen, iframeSrc, onClose, onPrint }) {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 200,
        background: "rgba(0,0,0,0.82)",
        backdropFilter: "blur(8px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: "16px",
        padding: "20px",
      }}
      onClick={onClose}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          background: "var(--bg2)",
          border: "1px solid var(--border)",
          borderRadius: "12px",
          padding: "10px 16px",
          maxWidth: "900px",
          width: "100%",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <span style={{ fontSize: "12px", color: "var(--text-muted)" }}>
          Preview
        </span>
        <div style={{ marginLeft: "auto", display: "flex", gap: "8px" }}>
          <button
            style={{
              padding: "7px 14px",
              borderRadius: "40px",
              background: "var(--accent)",
              color: "white",
              border: "none",
              cursor: "pointer",
            }}
            onClick={onPrint}
          >
            Print / Save PDF
          </button>
          <button
            style={{
              padding: "7px 14px",
              borderRadius: "40px",
              background: "var(--bg3)",
              color: "var(--text-muted)",
              border: "1px solid var(--border)",
              cursor: "pointer",
            }}
            onClick={onClose}
          >
            ✕ Close
          </button>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          maxWidth: "900px",
          height: "70vh",
          background: "#fff",
          borderRadius: "8px",
          overflow: "hidden",
        }}
      >
        <iframe
          src={iframeSrc}
          title="Print Preview"
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      </div>
    </div>
  );
}
